import { useCallback, useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { useSupabaseClient } from './useSupabaseClient';
import type { AssignmentRow } from '../types/sinif';

/** Giriş yapan öğrencinin kendisine atanan görevlerini okur/tamamlar. */
export function useAssignments() {
  const { user } = useUser();
  const getSupabase = useSupabaseClient();
  const [assignments, setAssignments] = useState<AssignmentRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setAssignments([]);
      setIsLoading(false);
      return;
    }
    try {
      const supabase = await getSupabase();
      const { data, error } = await supabase
        .from('assignments')
        .select('*')
        .eq('student_id', user.id)
        .order('created_at', { ascending: false });
      setAssignments(error ? [] : ((data as AssignmentRow[]) ?? []));
    } catch {
      setAssignments([]);
    } finally {
      setIsLoading(false);
    }
  }, [user, getSupabase]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const markCompleted = useCallback(
    async (assignmentId: string) => {
      if (!user) return;
      const supabase = await getSupabase();
      await supabase
        .from('assignments')
        .update({ status: 'tamamlandi', completed_at: new Date().toISOString() })
        .eq('id', assignmentId)
        .eq('student_id', user.id);
      await refresh();
    },
    [user, getSupabase, refresh]
  );

  return { assignments, isLoading, markCompleted, refresh };
}
